<div class="aid-preview" [ngStyle]="vars">
  <!-- Interface Liquid: Canvas-Animation — der Zeiger tippt die passende Frage,
       die Lernhilfe erscheint als Antwort im Chat (answer → play). Ohne Liquid
       ist der Rahmen durchlässig und zeigt nur die Blase. -->
  <app-liquid-demo
    scenario="aid"
    [on]="frame === 'liquid'"
    [styles]="styles"
    [active]="active"
    [typeText]="questionKey | translate"
    [replayKey]="index"
    (answer)="onDemoAnswer()"
  >
  <div class="bubble" [style.background]="bubbleFill" [style.color]="bubbleText">
    <p class="bubble__text">{{ introKey | translate }}</p>

    <section #card class="lb" [class.lb--loading]="phase === 'loading'" [class.lb--revealing]="phase === 'revealing'"
             [attr.aria-busy]="phase !== 'done'">
      <div #content class="lb__content" [class.is-in]="contentIn">
        @switch (sample) {
          <!-- Kacheln: eine zu (Box), eine offen (Box aktiv + Rahmen), Icons -->
          @case ('tiles') {
            <h3 class="lb__title">{{ 'pages.chatStyling.preview.aid.tilesTitle' | translate }}</h3>
            <div class="tiles">
              <div class="tile tile--open">
                <span class="tile__icon"><nb-icon icon="percent-outline"></nb-icon></span>
                <span class="tile__label">{{ 'pages.chatStyling.preview.aid.tile1' | translate }}</span>
                <span class="tile__detail">{{ 'pages.chatStyling.preview.aid.tile1Detail' | translate }}</span>
              </div>
              <div class="tile">
                <span class="tile__icon"><nb-icon icon="briefcase-outline"></nb-icon></span>
                <span class="tile__label">{{ 'pages.chatStyling.preview.aid.tile2' | translate }}</span>
              </div>
            </div>
          }

          <!-- Aufzählung: Punkte als Boxen, Nummern als Buttons -->
          @case ('points') {
            <h3 class="lb__title">{{ 'pages.chatStyling.preview.aid.pointsTitle' | translate }}</h3>
            <ol class="points">
              @for (n of [1, 2, 3]; track n) {
                <li>
                  <span class="points__marker">{{ n }}</span>
                  <span>{{ 'pages.chatStyling.preview.aid.point' + n | translate }}</span>
                </li>
              }
            </ol>
          }

          <!-- Rechner: Marke, Akzentwert, Regler (Schiene + Füllung), Ergebnis -->
          @case ('calc') {
            <span class="lb__kicker">{{ 'pages.chatStyling.preview.aid.calcKicker' | translate }}</span>
            <h3 class="lb__title">{{ 'pages.chatStyling.preview.aid.calcTitle' | translate }}</h3>
            <div class="calc__row">
              <span>{{ 'pages.chatStyling.preview.aid.calcInput' | translate }}</span>
              <span class="calc__value">{{ rate.toFixed(1).replace('.', ',') }} %</span>
            </div>
            <div class="range" [style.--p]="fillPercent">
              <div class="range__track"></div>
              <div class="range__fill"></div>
              <input type="range" min="0.1" max="1" step="0.1" [value]="rate" (input)="rate = +$any($event.target).value"
                     [attr.aria-label]="'pages.chatStyling.preview.aid.calcInput' | translate" />
            </div>
            <div class="calc__result">
              <span class="lb__muted">{{ 'pages.chatStyling.preview.aid.calcResult' | translate }}</span>
              <span class="calc__result-value">{{ result }} Mrd. $</span>
            </div>
            <p class="lb__note">{{ 'pages.chatStyling.preview.aid.calcNote' | translate }}</p>
          }

          <!-- Ablauf: Knoten (Box), hervorgehoben (Box aktiv), Pfeile (Linien) -->
          @case ('flow') {
            <h3 class="lb__title">{{ 'pages.chatStyling.preview.aid.flowTitle' | translate }}</h3>
            <div class="flow__node"><nb-icon icon="credit-card-outline"></nb-icon><b>{{ 'pages.chatStyling.preview.aid.flow1' | translate }}</b></div>
            <div class="flow__arrow">↓</div>
            <div class="flow__node flow__node--hl"><b>{{ 'pages.chatStyling.preview.aid.flow2' | translate }}</b></div>
            <div class="flow__arrows"><span>↓</span><span>↓</span></div>
            <div class="flow__split">
              <div class="flow__node"><nb-icon icon="shield-outline"></nb-icon><b>{{ 'pages.chatStyling.preview.aid.flow3' | translate }}</b></div>
              <div class="flow__node"><nb-icon icon="trending-up-outline"></nb-icon><b>{{ 'pages.chatStyling.preview.aid.flow4' | translate }}</b></div>
            </div>
          }

          <!-- Karteikarten: Rückseite (Box aktiv + Linie), Vor/Zurück aktiv und gesperrt -->
          @case ('cards') {
            <h3 class="lb__title">{{ 'pages.chatStyling.preview.aid.cardsTitle' | translate }}</h3>
            <div class="card-back">
              <p>{{ 'pages.chatStyling.preview.aid.cardBack' | translate }}</p>
            </div>
            <div class="cards__nav">
              <span class="nav-btn nav-btn--inactive"><nb-icon icon="arrow-ios-back-outline"></nb-icon></span>
              <span class="lb__muted">1 / 4</span>
              <span class="nav-btn"><nb-icon icon="arrow-ios-forward-outline"></nb-icon></span>
            </div>
          }
        }
      </div>

      <!-- Ladeanimation der gewählten Variante (echter Lader), läuft einmal -->
      <div class="lb__cover" [class.lb__cover--off]="phase === 'done'" aria-hidden="true">
        <canvas #loaderCanvas class="lb__canvas"></canvas>
      </div>
      @if (phase !== 'done' && loader === 'pixel-glitter') {
        <span class="lb__loading-text">{{ 'pages.chatStyling.preview.aid.loading' | translate }}</span>
      }
    </section>
  </div>
  </app-liquid-demo>

  <!-- Blättern zwischen den Beispiel-Lernhilfen -->
  <div class="aid-nav">
    <button type="button" class="al-icon-button al-icon-button--primary" (click)="go(-1)"
            [attr.aria-label]="'pages.chatStyling.preview.aid.prev' | translate">
      <nb-icon icon="arrow-ios-back-outline"></nb-icon>
    </button>
    <span class="aid-nav__count">{{ index + 1 }} / {{ samples.length }}</span>
    <button type="button" class="al-icon-button al-icon-button--primary" (click)="go(1)"
            [attr.aria-label]="'pages.chatStyling.preview.aid.next' | translate">
      <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </button>
  </div>
</div>
